import { useEffect, useState } from "react";
import { HardDrive } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { act } from "@/lib/hooks";
import { api } from "@/lib/api";
import { Section, Field } from "@/components/common";

const GB = 1024 ** 3;

export function TenantStorageCard({ tid, usage, reload }) {
  const [f, setF] = useState({ storage_gb: "", storage_addon_qty: 0 });
  const addon = usage.storage_addon_qty || 0;
  const limit = usage.storage_limit_gb;
  useEffect(() => { setF({ storage_gb: limit != null ? limit - 10 * addon : "", storage_addon_qty: addon }); }, [limit, addon]);
  const used = usage.storage_used_bytes || 0;
  const pct = limit ? Math.min(100, (used / (limit * GB)) * 100) : 0;
  const total = (Number(f.storage_gb) || 0) + 10 * (Number(f.storage_addon_qty) || 0);
  const save = async () => {
    if (await act(() => api.put(`/platform/tenants/${tid}/storage`, { storage_gb: f.storage_gb === "" ? null : Number(f.storage_gb), storage_addon_qty: Number(f.storage_addon_qty) || 0 }), "Storage updated")) reload();
  };
  return (
    <Section title={<span className="inline-flex items-center gap-2"><HardDrive className="h-4 w-4" />File storage</span>} testId="tenant-storage">
      <div className="space-y-4 p-5">
        <div>
          <div className="flex justify-between text-sm"><span data-testid="tenant-storage-used">{(used / GB).toFixed(2)} GB used</span>
            <span className="text-slate-500" data-testid="tenant-storage-limit">of {limit ?? "—"} GB ({pct.toFixed(1)}%)</span></div>
          <div className="mt-2 h-2 rounded-full bg-slate-100"><div className={`h-2 rounded-full ${pct >= 90 ? "bg-rose-500" : pct >= 75 ? "bg-amber-500" : "bg-emerald-500"}`} style={{ width: `${pct}%` }} /></div>
        </div>
        <div className="grid gap-3 sm:grid-cols-3">
          <Field label="Base limit (GB)"><Input type="number" min="1" data-testid="storage-base-gb-input" value={f.storage_gb} onChange={(e) => setF({ ...f, storage_gb: e.target.value })} /></Field>
          <Field label="Extra storage 10 GB add-ons"><Input type="number" min="0" data-testid="storage-addon-qty-input" value={f.storage_addon_qty} onChange={(e) => setF({ ...f, storage_addon_qty: e.target.value })} /></Field>
          <div className="flex items-end gap-3"><span className="text-sm text-slate-600" data-testid="storage-total-preview">Total: {total} GB</span>
            <Button data-testid="storage-save-button" onClick={save} className="bg-[#13294B] hover:bg-[#1c3a66]">Save storage</Button></div>
        </div>
      </div>
    </Section>
  );
}
